module.exports = "<!-- <input type=\"file\" (change)=\"fileChange($event)\" placeholder=\"Upload file\" >\n<div *ngIf=\"warunek == true\"><img bind-src=\"url\"></div> -->\n\n<mat-card class=\"card1\">\n    <mat-card-header>\n      <mat-card-title><h1>Dialog Demo</h1></mat-card-title>\n    </mat-card-header>\n    <hr>\n    <mat-card-content>\n      <button mat-raised-button (click)=\"openDialog()\">Open Dialog</button>\n      <hr>\n      <strong>Result: {{dialogResult}}</strong>\n    </mat-card-content>\n  </mat-card>"


//////////////////
// WEBPACK FOOTER
// ./src/app/image-test/image-test.component.html
// module id = ./src/app/image-test/image-test.component.html
// module chunks = main